import mixin from '@/mixin/index.js';
const { _isCordovaApp, _isIos } = mixin.methods;

const handleStatusBar = (meta) => {
    if (_isIos()) {
        StatusBar.overlaysWebView(meta.hideStatusBar);
        StatusBar.backgroundColorByName(meta.statusBarColor);
    } else if (_isCordovaApp()) {
        StatusBar.overlaysWebView(false);
    }
}

export {
    handleStatusBar
}